(function($) {
    $.fn.tabGroup = function() {
        var $tabGroups = this,
            keys = {
                end: 35,
                home: 36,
                left: 37,
                right: 39,
                enter: 13,
                space: 32
            };

        $tabGroups.each(function() {
            var $tabGroup = $(this),
                $tabList = $tabGroup.find('[role="tablist"]'),
                $tabs = $tabList.find('[role="tab"]'),
                $panels = $tabGroup.find('[role="tabpanel"]');

            function clickEventListener() {
                var $tab = $(this);
                activateTab($tab, false);
            }

            function activateTab($tab, setFocus) {
                var panelId = $tab.attr('aria-controls'),
                    $panel = $panels.filter(`#${panelId}`);
                setFocus = setFocus || true;
                deactivateTabs();
                $tab.removeAttr('tabindex').attr({
                    'aria-selected': 'true'
                });
                $panel.removeAttr('hidden');
                if (setFocus) {
                    $tab.focus();
                };
            };

            function deactivateTabs() {
                $tabs.attr({
                    tabindex: '-1',
                    'aria-selected': 'false'
                });
                $panels.attr({
                    hidden: 'hidden'
                });
            };

            function keydownEventListener(event) {
                var key = event.keyCode;
                switch (key) {
                case keys.home:
                    event.preventDefault();
                    focusFirstTab();
                    break;
                case keys.end:
                    event.preventDefault();
                    focusLastTab();
                    break;
                };
            };

            function focusFirstTab() {
                $tabs.first().focus();
            };

            function focusLastTab() {
                $tabs.last().focus();
            };

            function keyupEventListener(event) {
                var key = event.keyCode,
                    $tab = $(this);
                switch (key) {
                case keys.left:
                    if ($tab.prev().length > 0) {
                        $tab.prev().focus();
                    }
                    break;
                case keys.right:
                    if ($tab.next().length > 0) {
                        $tab.next().focus();
                    }
                    break;
                case keys.enter:
                case keys.space:
                    activateTab($tab);
                    break;
                };
            };

            $tabs.each(function() {
                var $tab = $(this);
                $tab.click(clickEventListener);
                $tab.keydown(keydownEventListener);
                $tab.keyup(keyupEventListener);
            });
        });
    };
}(jQuery));
